import { HourglassTop, OpenInBrowser, TaskAlt } from "@mui/icons-material";
import { Alert, Button, FormControl, FormLabel, Grid, LinearProgress, Stack, TextField, Typography } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Api from "../api/Api";
import { AppBarContext } from "../context/AppBarContextProvider";
import { UserContext } from "../context/UserContextProvider";
import { PAYMENT_MAP, numberFormat } from "../core/utils";
const ViewPaymentPage = () => {
    const { id } = useParams();
    const { user } = useContext(UserContext);
    const { setTitle } = useContext(AppBarContext);
    const [item, setItem] = useState(undefined);

    useEffect(() => {
        if (user) {
            let timeoutHandler;
            const fetchItem = async () => {
                try {
                    const mItem = await Api.getCampaign(id, user.idem_guid);
                    setItem(mItem);
                    setTitle(`${mItem.type} | Campaign ID #${id}`);
                    if (mItem.impressions.find((/** @type {{ paid: boolean; }} */ item) => item.paid === false)) { // update if we there is pending payment
                        timeoutHandler = setTimeout(() => fetchItem(), 5000);
                    }
                } catch (e) {
                    console.error(e);
                }
            }
            fetchItem();
            return () => {
                setTitle(undefined)
                clearTimeout(timeoutHandler);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    if (!item || !user) {
        return <Grid container spacing={2}>
            <Grid item xs={12}>
                <LinearProgress />
            </Grid>
        </Grid>;
    }
    const impression = item.impressions[0];

    return <Grid container spacing={2}>
        {item.type === 'sms' && <>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <FormLabel sx={{ color: 'white' }} >Message</FormLabel>
                    <TextField value={item.message} disabled />
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <FormLabel sx={{ color: 'white' }} >Phone Number</FormLabel>
                    <MuiTelInput value={impression.target} disabled />
                </FormControl>
            </Grid>
        </>}
        {item.type === 'social' && <>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <FormLabel sx={{ color: 'white' }} >Link</FormLabel>
                    <Stack direction={'row'} display={'flex'}>
                        <TextField value={impression.target} sx={{ ['& .MuiInputBase-root']: { borderTopRightRadius: 0, borderBottomRightRadius: 0 } }} disabled fullWidth />
                        <Button variant="outlined" href={impression.target} target="_blank" sx={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}><OpenInBrowser /></Button>
                    </Stack>
                </FormControl>
            </Grid>
        </>}
        <Grid item xs={12}>
            <Alert severity='info' sx={{ mb: 2 }}>
                <Stack direction={'row'} spacing={2}>
                    <Typography variant={'body1'}>
                        {`Payment status: ${numberFormat(PAYMENT_MAP[item.type])} mlx`}
                    </Typography>
                    {impression.paid ? <TaskAlt color='success' /> : <HourglassTop color='info' />}
                </Stack>
            </Alert>
        </Grid>
    </Grid>
}

export default ViewPaymentPage;